import React, { useState, useContext, useEffect } from 'react'
import { IonGrid, IonRow, IonCol, IonSearchbar, IonItem, IonItemDivider, IonIcon, IonModal, useIonViewWillEnter, IonFab, IonFabButton} from '@ionic/react'
import db from '../../resources/db'
import { add } from 'ionicons/icons'
import AddStocks from './AddStocks'
import { ConfigContext } from '../../contexts/ConfigContext'
import MaterialTable from 'material-table'
import tableIcons from '../../resources/tableIcons'
import { useRouter } from '../../resources/Hooks'

const StockDetails = () => {

    const { getStocks, getStocksValue } = useContext(ConfigContext);
    const [ShowModel, setShowModel] = useState(false);
    const [Stocks, setStocks] = useState([]);
    const [StocksValue, setStocksValue] = useState(0);
    const router = useRouter();

    useEffect(() => {
        getStocks().then(res => {
            setStocks(res)
        })
        getStocksValue().then(res => {
            setStocksValue(res)
        })
    }, [getStocks, getStocksValue])

    // console.log(Stocks);
    /** Search Stocks by Product Name */
    const searchStocks = (data) => {
        db.stocks.where("productName").startsWithIgnoreCase(data).toArray().then((res) => {
            setStocks(res)
        })
    }

    const StockTable = () => (
        <MaterialTable icons={tableIcons} title={`Stocks (Total Value: ₹ ${StocksValue.toFixed(2)})`} columns={[
            { title: 'Product ID', field: 'productId' },
            { title: 'Product Name', field: 'productName', cellStyle: { textTransform: 'capitalize'} },
            { title: 'HSN Code', field: 'hsn' },
            { title: 'In Stocks', field: 'quantity', type: 'numeric' },
            { title: 'Purchase Rate', field: 'purchaseRate', type: 'currency', currencySetting: { currencyCode: 'INR' } },
            { title: 'Sale Rate', field: 'rate', type: 'currency', currencySetting: { currencyCode: 'INR' } },
        ]} data={Stocks}
            onRowClick={(event, rowData) => {
                router.push('/stocks/' + rowData.productId)
            }}
            options={{
                exportButton: true,
                pageSize: 10,
                pageSizeOptions: [10, 20, 30, 40, 50],
                headerStyle: {
                    backgroundColor: '#989aa2',
                    color: '#FFF',
                    
                }
            }}  
        />
    )

    const Table = () => (<>
        <IonRow class='ion-justify-content-center'>
                <IonCol size='6' class='ion-align-self-center' >
                    <IonSearchbar placeholder='Search by Item Name' onIonChange={(e) => { searchStocks((e.target.value).trim()) }}></IonSearchbar>
                </IonCol>
            </IonRow>

            <IonRow class='ion-justify-content-center'>

                <IonItemDivider>
                    <IonCol sizeMd='1' class='ion-align-self-center'>
                        <strong style={{ color: 'black' }}>Product ID</strong>
                    </IonCol>
                    <IonCol size='3'>
                        <strong style={{ color: 'black' }}>Product Name</strong>
                    </IonCol>
                    <IonCol>
                        <strong style={{ color: 'black' }}>HSN Code</strong>
                    </IonCol>
                    <IonCol>
                        <strong style={{ color: 'black' }}>In Stocks</strong>
                    </IonCol>
                    <IonCol>
                        <strong style={{ color: 'black' }}>Purchase Rate</strong>
                    </IonCol>
                    <IonCol>
                        <strong style={{ color: 'black' }}>Sale Rate</strong>
                    </IonCol>
                </IonItemDivider>
            </IonRow>
        {
            /**Stocks Table UI */
            Stocks.length ? (
                Stocks.map((item) => {
                    return (
                        <IonItem routerLink={`/stocks/` + item.productId} class='ion-align-self-center' key={item.productId}>
                            <IonCol sizeMd='1' >{item.productId}</IonCol>
                            <IonCol size='3' style={{ textTransform: 'capitalize' }}>{item.productName}</IonCol>
                            <IonCol>{item.hsn}</IonCol>
                            <IonCol>{(item.quantity).toFixed(2)}</IonCol>
                            <IonCol>₹ {(item.purchaseRate).toFixed(2)}</IonCol>
                            <IonCol>₹ {(item.rate).toFixed(2)}</IonCol>
                        </IonItem>
                    )
                })
            ) : (<div></div>)
        }
        {
            StocksValue ? (
                <IonItem>
                    <IonCol size='7'>Total Stock Value :</IonCol>
                    <IonCol >&#8377; {StocksValue.toFixed(2)}</IonCol>
                </IonItem>
            ) : ('')
        }
    </>)

    return (
        <IonGrid >
            
            <StockTable />
            {/* <Table /> */}

            <IonFab vertical="bottom" horizontal="end">
                <IonFabButton onClick={() => setShowModel(true)}>
                    <IonIcon icon={add} />
                </IonFabButton>
            </IonFab>
            

            <IonModal isOpen={ShowModel} cssClass='stockupdate' onDidDismiss={() => setShowModel(false)} >
                <AddStocks setStocks={setStocks} setShowModel={setShowModel} />
            </IonModal>
        </IonGrid>
    )
}

export default StockDetails
